import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
  allowedLanguages : [],
  tokenTranslations : []
};

const getters = {
  getAllowedLanguages: (state) => state.allowedLanguages,
  getTokenTranslationsForLanguage: (state) => state.tokenTranslations
};

const actions = {
  async getAllowedLanguages( context ) {
      await axios.get(`${backendUrl()}/getAllowedLanguages`,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setAllowedLanguages', response.data)
      })
  },
  async getTokenTranslationsForLanguage( context, data ) {
      await axios.post(`${backendUrl()}/getTokenTranslationsForLanguage`, data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
          context.commit('setTokenTranslations', response.data)
      })
  },
  async addTokenTranslation( context, data ) {
      await axios.post(`${backendUrl()}/addTokenTranslation`, data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async deleteTokenTranslation( context, data ) {
      await axios.post(`${backendUrl()}/deleteTokenTranslation`, data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
  async editTokenTranslation( context, data ) {
      await axios.post(`${backendUrl()}/editTokenTranslation`, data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      }).then(response => {
        context.dispatch('handleResponse', response, {root: true})
      })
  },
};

const mutations = {
  setAllowedLanguages:(state, allowedLanguages) => (state.allowedLanguages = allowedLanguages),
  setTokenTranslations:(state, tokenTranslations) => (state.tokenTranslations = tokenTranslations)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
